// extracted by mini-css-extract-plugin
export default {"myName":"Home_myName__8KXBU","helloWord":"Home_helloWord__hnLlB","paragraph":"Home_paragraph__nnDdv"};